import * as yup from "yup";
import { definedDecimalStr } from "utils/schemas/decimalStr";
import { makeFormatDecimal } from "utils/formatting";
import dimensionsSchema from "utils/schemas/dimensions";
import { getEnumSchema } from "utils/schemas/utils";
import { SkuComponentType } from "__generated__/gql/graphql";

const upcValidation = yup
  .string()
  .nullable()
  .defined()
  .default(null)
  .trim()
  .transform((value: string) => {
    if (!value) return value;
    return String(value).replace(/[-\s]/g, "");
  })
  .matches(/^(\d{8}|\d{12,14})$/, {
    excludeEmptyString: true,
    message:
      "UPCs should be between 8, 12, 13 or 14 digits (excluding dashes) and should not contain letters",
  });

export const skuId = yup.string().uuid().label("SKU").required();

export const skuComponentType =
  getEnumSchema<SkuComponentType>(SkuComponentType);

export const upc = upcValidation.label("UPC");

const formatPounds = makeFormatDecimal({ style: "unit", unit: "pound" });

export const grossWeightLbs = definedDecimalStr({
  numberFormatter: formatPounds,
})
  .min(0)
  .max(1000, { isExclusive: true })
  .label("Gross Weight");

export const dimensions = dimensionsSchema.label("Dimensions");

const skuComponent = yup.object().shape({
  skuComponentType,
  upc,
  grossWeightLbs,
  dimensions,
});

export default skuComponent;
